import { Analytics, Environment, Track } from '@1debit/analytics';
import { EventMappings } from '@1debit/chime-schemas/typescript_web_analytics';
import { isPerformanceConsented } from './eventRouterGate';

export const appEnvironment = (process.env.ENV || process.env.NODE_ENV) as Environment;

export const analyticsHandler = new Analytics({ env: appEnvironment, variant: 'onlyEventRouter' });

export { initConsentGate } from './eventRouterGate';

/**
 * Drop-in for `analyticsHandler.trackEvent` that suppresses the call when the
 * user has not consented to OneTrust Performance (C0002).
 *
 * Why all events, not just payloads with known PII keys: the SDK auto-attaches
 * `page.url` and `page.search` to every event it builds, and those carry ad
 * identifiers (`gclid`, `fbclid`, `utm_*`) whenever the visitor lands on a
 * paid-traffic URL. There is no such thing as a non-PII EventRouter event in
 * that case. Mirrors how Segment + Statsig are gated elsewhere in the program.
 */
export function trackEvent<EventName extends Exclude<Track, Track.WebPageViewed>>(
  eventName: EventName,
  properties: EventMappings[EventName],
): void {
  if (!isPerformanceConsented()) return;
  analyticsHandler.trackEvent(eventName, properties);
}
